import { render, staticRenderFns } from "./LsvaOverviewTrucksTableView.vue?vue&type=template&id=1533577d&scoped=true&"
import script from "./LsvaOverviewTrucksTableView.vue?vue&type=script&lang=js&"
export * from "./LsvaOverviewTrucksTableView.vue?vue&type=script&lang=js&"
import style0 from "./LsvaOverviewTrucksTableView.vue?vue&type=style&index=0&id=1533577d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533577d",
  null
  
)

/* custom blocks */
import block0 from "./LsvaOverviewTrucksTableView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports